import Vue from "vue";
import Router from "vue-router";
import BaseRouter from "views/common/base-router.vue";
import layout from "views/layout/index";

Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "layout",
        component: resolve => require(["../views/layout/index.vue"], resolve),
        redirect: "/Login",
        //redirect: "/first",
        children: [
            {
                path: "/first",
                name: "欢迎",
                component: resolve =>
                    require(["../views/business/first.vue"], resolve),
                meta: {
                    title: "欢迎"
                }
            },
            //外集卡系统
            {
                path: "/outCard/monitorPlatform",
                name: "港区监控平台",
                component: resolve =>
                    require(["../views/business/outCard/monitorPlatform.vue"], resolve),
                meta: {
                    title: "港区监控平台"
                }
            },
            {
                path: "/outCard/businessPlatform",
                name: "业务监控平台",
                component: resolve =>
                    require(["../views/business/outCard/businessPlatform.vue"], resolve),
                meta: {
                    title: "业务监控平台"
                }
            },
            {
                path: "/outCard/SystemS",
                name: "系统管理工作台",
                component: resolve =>
                    require(["../views/business/system/index.vue"], resolve),
                meta: {
                    title: "系统管理工作台"
                }
            },
            {
                path: "/shipsWork/index",
                name: "船舶工作台",
                component: resolve =>
                    require(["../views/business/shipsWork/index.vue"], resolve),
                meta: {
                    title: "船舶工作台"
                }
            },
            {
                path: "/shipsWork/shipFiles",
                name: "船舶档案",
                component: resolve =>
                    require(["../views/business/shipsWork/shipFiles.vue"], resolve),
                meta: {
                    title: "船舶档案"
                }
            },
            {
                path: "/shipsWork/declarPlan",
                name: "船舶计划申报",
                component: resolve =>
                    require(["../views/business/shipsWork/declarPlan.vue"], resolve),
                meta: {
                    title: "船舶计划申报"
                }
            },
            {
                path: "/shipsWork/declarLoadingList",
                name: "装卸船清单申报",
                component: resolve =>
                    require(["../views/business/shipsWork/declarLoadingList.vue"], resolve),
                meta: {
                    title: "装卸船清单申报"
                }
            },
            {
                path: "/shipsWork/shipOperationTracking",
                name: "船舶作业跟踪",
                component: resolve =>
                    require(["../views/business/shipsWork/shipOperationTracking.vue"], resolve),
                meta: {
                    title: "船舶作业跟踪"
                }
            },
            {
                path: "/shipsWork/loadWorkCheck",
                name: "捣载作业查询",
                component: resolve =>
                    require(["../views/business/shipsWork/loadWorkCheck.vue"], resolve),
                meta: {
                    title: "捣载作业查询"
                }
            },
            {
                path: "/Home/SystemS/SystemParameter",
                name: "系统参数管理",
                component: resolve =>
                    require([
                        "../views/business/system/systemParameter.vue"
                    ], resolve),
                meta: {
                    title: "系统参数管理"
                }
            },
            {
                path: "/Home/SystemS/SystemDictionary",
                name: "系统字典",
                component: resolve =>
                    require([
                        "../views/business/system/systemDictionary.vue"
                    ], resolve),
                meta: {
                    title: "系统字典"
                }
            },
            {
                path: "/Home/SystemS/SystemUser",
                name: "登录账户管理",
                component: resolve =>
                    require([
                        "../views/business/system/SystemUser.vue"
                    ], resolve),
                meta: {
                    title: "登录账户管理"
                }
            },
            {
                path: "/Home/SystemS/usbKey",
                name: "USBkey管理",
                component: resolve =>
                    require([
                        "../views/business/system/usbKey.vue"
                    ], resolve),
                meta: {
                    title: "USBkey管理"
                }
            },
            {
                path: "/Home/SystemS/AppInfo",
                name: "应用管理",
                component: resolve =>
                    require(["../views/business/system/appInfo.vue"], resolve),
                meta: {
                    title: "应用管理"
                }
            },
            {
                path: "/Home/SystemS/AppVersion",
                name: "应用版本管理",
                component: resolve =>
                    require([
                        "../views/business/system/appVersion.vue"
                    ], resolve),
                meta: {
                    title: "应用版本管理"
                }
            },
            {
                path: "/Home/SystemS/pxLog",
                name: "培训记录",
                component: resolve =>
                    require([
                        "../views/business/system/pxLog.vue"
                    ], resolve),
                meta: {
                    title: "培训记录"
                }
            },
            {
                path: "/Home/SystemS/news",
                name: "消息管理",
                component: resolve =>
                    require([
                        "../views/business/system/news.vue"
                    ], resolve),
                meta: {
                    title: "消息管理"
                }
            },
            {
                path: "/Home/SystemS/reply",
                name: "回复管理",
                component: resolve =>
                    require([
                        "../views/business/system/reply.vue"
                    ], resolve),
                meta: {
                    title: "回复管理"
                }
            },
            {
                path: "/Home/SystemS/appointmentPlan",
                name: "计划预约",
                component: resolve =>
                    require([
                        "../views/business/system/appointmentPlan.vue"
                    ], resolve),
                meta: {
                    title: "计划预约"
                }
            },
            {
                path: "/Home/SystemS/appointmentDetial",
                name: "计划预约",
                component: resolve =>
                    require([
                        "../views/business/system/appointmentDetial.vue"
                    ], resolve),
                meta: {
                    title: "计划预约"
                }
            },
            {
                path: "/Home/SystemS/appointmentStatistics",
                name: "预约统计",
                component: resolve =>
                    require([
                        "../views/business/system/appointmentStatistics.vue"
                    ], resolve),
                meta: {
                    title: "预约统计"
                }
            },
            {
                path: "/Home/SystemS/headerNews",
                name: "站内信",
                component: resolve =>
                    require([
                        "../views/business/system/headerNews.vue"
                    ], resolve),
                meta: {
                    title: "站内信"
                }
            },
            {
                path: "/Home/SystemS/vehicleQuery",
                name: "车辆查询",
                component: resolve =>
                    require([
                        "../views/business/system/vehicleQuery.vue"
                    ], resolve),
                meta: {
                    title: "车辆查询"
                }
            },
            {
                path: "/Home/SystemS/vehicleQueryDetail",
                name: "查看车辆作业记录",
                component: resolve =>
                    require([
                        "../views/business/system/vehicleQueryDetail.vue"
                    ], resolve),
                meta: {
                    title: "查看车辆作业记录"
                }
            },
            {
                path: "/Home/SystemS/driverQuery",
                name: "司机查询",
                component: resolve =>
                    require([
                        "../views/business/system/driverQuery.vue"
                    ], resolve),
                meta: {
                    title: "司机查询"
                }
            },
            {
                path: "/Home/SystemS/driverQueryDetail",
                name: "查看司机作业记录",
                component: resolve =>
                    require([
                        "../views/business/system/driverQueryDetail.vue"
                    ], resolve),
                meta: {
                    title: "查看司机作业记录"
                }
            },
            {
                path: "/outCard/shipCompany",
                name: "放箱工作台",
                component: resolve =>
                    require(["../views/business/outCard/shipCompany.vue"], resolve),
                meta: {
                    title: "放箱工作台"
                }
            },
            {
                path: "/outCard/trailerCompany",
                name: "任务处理工作台",
                component: resolve =>
                    require(["../views/business/outCard/trailerCompany.vue"], resolve),
                meta: {
                    title: "任务处理工作台"
                }
            },
            {
                path: "/outCard/basePlatform",
                name: "基础管理工作台",
                component: resolve =>
                    require(["../views/business/outCard/basePlatform.vue"], resolve),
                meta: {
                    title: "基础管理工作台"
                }
            },
            {
                path: "/outCard/cargoStation",
                name: "货站工作平台",
                component: resolve =>
                    require(["../views/business/outCard/cargoStation.vue"], resolve),
                meta: {
                    title: "货站工作平台"
                }
            },
            {
                path: "/outCard/loadedContainer/send",
                name: "重箱放箱操作",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/send.vue"], resolve),
                meta: {
                    title: "重箱放箱操作"
                }
            },
            {
                path: "/outCard/outContainer/outBox",
                name: "外进箱放箱",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/outBox.vue"], resolve),
                meta: {
                    title: "外进箱放箱"
                }
            },
            {
                path: "/outCard/loadedContainer/loadedJob/:id",
                name: "重箱作业",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/loadedJob.vue"], resolve),
                meta: {
                    title: "重箱作业"
                }
            },
            {
                path: "/outCard/loadedContainer/loadedJobNew/:id",
                name: "重箱作业",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/loadedJobNew.vue"], resolve),
                meta: {
                    title: "重箱作业"
                }
            },
            {
                path: "/outCard/emptyContainer/emptyJob/:id",
                name: "空箱作业",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptyJob.vue"], resolve),
                meta: {
                    title: "空箱作业"
                }
            },
            {
                path: "/outCard/emptyContainer/emptyJobNew/:id",
                name: "空箱作业",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptyJobNew.vue"], resolve),
                meta: {
                    title: "空箱作业"
                }
            },
            {
                path: "/outCard/emptyContainer/emptyChooseBox",
                name: "预约选空箱",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptyChooseBox.vue"], resolve),
                    //require(["../views/business/outCard/emptyContainer/emptyJobNew.vue"], resolve),
                meta: {
                    title: "预约选空箱"
                }
            },
            {
                path: "/outCard/emptyContainer/emptyChooseBoxDetial",
                name: "预约选空箱详情",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptyChooseBoxDetial.vue"], resolve),
                    //require(["../views/business/outCard/emptyContainer/emptyJobNew.vue"], resolve),
                meta: {
                    title: "预约选空箱详情"
                }
            },
            {
                path: "/outCard/outContainer/outJob/:id",
                name: "外进箱作业",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/outJob.vue"], resolve),
                meta: {
                    title: "外进箱作业"
                }
            },
            {
                path: "/outCard/outContainer/outJobNew/:id",
                name: "外进箱作业",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/outJobNew.vue"], resolve),
                meta: {
                    title: "外进箱作业"
                }
            },
            {
                path: "/outCard/fee/feeJob/:id",
                name: "待对账费用",
                component: resolve =>
                    require(["../views/business/outCard/fee/feeJob.vue"], resolve),
                meta: {
                    title: "待对账费用"
                }
            },
            {
                path: "/outCard/emptyContainer/emptySendApply",
                name: "空箱放箱申请列表",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptySendApply.vue"], resolve),
                meta: {
                    title: "空箱放箱申请列表"
                }
            },
            {
                path: "/outCard/outContainer/damaged",
                name: "进场重箱残损确认",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/damaged.vue"], resolve),
                meta: {
                    title: "进场重箱残损确认"
                }
            },
            {
                path: "/outCard/fee/confirmFee",
                name: "待确认费用",
                component: resolve =>
                    require(["../views/business/outCard/fee/confirmFee.vue"], resolve),
                meta: {
                    title: "待确认费用"
                }
            },
            {
                path: "/outCard/fee/feeRecord",
                name: "对账记录",
                component: resolve =>
                    require(["../views/business/outCard/fee/feeRecord.vue"], resolve),
                meta: {
                    title: "对账记录"
                }
            },
            {
                path: "/outCard/fee/feeModel",
                name: "费用模板管理",
                component: resolve =>
                    require(["../views/business/outCard/fee/feeModel.vue"], resolve),
                meta: {
                    title: "费用模板管理"
                }
            },
            {
                path: "/outCard/userManage/temporary",
                name: "临时客户管理",
                component: resolve =>
                    require(["../views/business/outCard/userManage/temporary.vue"], resolve),
                meta: {
                    title: "临时客户管理"
                }
            },
            {
                path: "/outCard/userManage/user",
                name: "用户管理",
                component: resolve =>
                    require(["../views/business/outCard/userManage/user.vue"], resolve),
                meta: {
                    title: "用户管理"
                }
            },
            {
                path: "/outCard/userManage/role",
                name: "角色管理",
                component: resolve =>
                    require(["../views/business/outCard/userManage/role.vue"], resolve),
                meta: {
                    title: "角色管理"
                }
            },
            {
                path: "/outCard/userManage/billModel",
                name: "电子提单模板",
                component: resolve =>
                    require(["../views/business/outCard/userManage/billModel.vue"], resolve),
                meta: {
                    title: "电子提单模板"
                }
            },
            {
                path: "/outCard/userManage/SpecialNeeds",
                name: "特殊需求申报",
                component: resolve =>
                    require(["../views/business/outCard/userManage/SpecialNeeds.vue"], resolve),
                meta: {
                    title: "电子提单模板"
                }
            },
            {
                path: "/outCard/userManage/fileModel",
                name: "导入文件管理",
                component: resolve =>
                    require(["../views/business/outCard/userManage/fileModel.vue"], resolve),
                meta: {
                    title: "导入文件管理"
                }
            },
            {
                path: "/outCard/loadedContainer/loadedBill",
                name: "提货单",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/loadedBill.vue"], resolve),
                meta: {
                    title: "提货单"
                }
            },
            {
                path: "/outCard/loadedContainer/viewPlan/:id",
                name: "提重箱计划查看",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/viewPlan.vue"], resolve),
                meta: {
                    title: "提重箱计划查看"
                }
            },
            {
                path: "/outCard/emptyContainer/viewPlan/:id",
                name: "提空箱计划查看",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/viewPlan.vue"], resolve),
                meta: {
                    title: "提空箱计划查看"
                }
            },
            {
                path: "/outCard/outContainer/viewPlan/:id",
                name: "外进箱计划查看",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/viewPlan.vue"], resolve),
                meta: {
                    title: "外进箱计划查看"
                }
            },
            {
                path: "/outCard/trailerLoaded/loadedBill",
                name: "重箱提单",
                component: resolve =>
                    require(["../views/business/outCard/trailerLoaded/loadedBill.vue"], resolve),
                meta: {
                    title: "重箱提单"
                }
            },
            {
                path: "/outCard/trailerLoaded/loadedReverBill",
                name: "查看已撤销重箱计划",
                component: resolve =>
                    require(["../views/business/outCard/trailerLoaded/loadedReverBill.vue"], resolve),
                meta: {
                    title: "查看已撤销重箱计划"
                }
            },
            {
                path: "/outCard/trailerEmpty/emptyBill",
                name: "空箱提单",
                component: resolve =>
                    require(["../views/business/outCard/trailerEmpty/emptyBill.vue"], resolve),
                meta: {
                    title: "空箱提单"
                }
            },
            {
                path: "/outCard/trailerEmpty/emptyReverBill",
                name: "查看已撤销空箱计划",
                component: resolve =>
                    require(["../views/business/outCard/trailerEmpty/emptyReverBill.vue"], resolve),
                meta: {
                    title: "查看已撤销空箱计划"
                }
            },
            {
                path: "/outCard/trailerOut/outBill/:id",
                name: "提单处理记录",
                component: resolve =>
                    require(["../views/business/outCard/trailerOut/outBill.vue"], resolve),
                meta: {
                    title: "提单处理记录"
                }
            },
            {
                path: "/outCard/trailerOut/outReverBill",
                name: "查看已撤销外进计划",
                component: resolve =>
                    require(["../views/business/outCard/trailerOut/outReverBill.vue"], resolve),
                meta: {
                    title: "查看已撤销外进计划"
                }
            },
            // {
            //     path: "/outCard/trailerLoaded/trailerLoadedJob/:id",
            //     name: "拖车公司重箱作业",
            //     component: resolve =>
            //         require(["../views/business/outCard/trailerLoaded/trailerLoadedJob.vue"], resolve),
            //     meta: {
            //         title: "拖车公司重箱作业"
            //     }
            // },
            {
                path: "/outCard/trailerLoaded/trailerLoadedJobNew/:id",
                name: "拖车公司重箱作业",
                component: resolve =>
                    require(["../views/business/outCard/trailerLoaded/trailerLoadedJobNew.vue"], resolve),
                meta: {
                    title: "拖车公司重箱作业"
                }
            },
            // {
            //     path: "/outCard/trailerEmpty/trailerEmptyJob/:id",
            //     name: "拖车公司空箱作业",
            //     component: resolve =>
            //         require(["../views/business/outCard/trailerEmpty/trailerEmptyJob.vue"], resolve),
            //     meta: {
            //         title: "拖车公司空箱作业"
            //     }
            // },
            {
                path: "/outCard/trailerEmpty/trailerEmptyJobNew/:id",
                name: "拖车公司空箱作业",
                component: resolve =>
                    require(["../views/business/outCard/trailerEmpty/trailerEmptyJobNew.vue"], resolve),
                meta: {
                    title: "拖车公司空箱作业"
                }
            },
            // {
            //     path: "/outCard/trailerOut/trailerOutJob/:id",
            //     name: "拖车公司外进箱作业",
            //     component: resolve =>
            //         require(["../views/business/outCard/trailerOut/trailerOutJob.vue"], resolve),
            //     meta: {
            //         title: "拖车公司外进箱作业"
            //     }
            // },
            {
                path: "/outCard/trailerOut/trailerOutJobNew/:id",
                name: "拖车公司外进箱作业",
                component: resolve =>
                    require(["../views/business/outCard/trailerOut/trailerOutJobNew.vue"], resolve),
                meta: {
                    title: "拖车公司外进箱作业"
                }
            },
            {
                path: "/outCard/trailerLoaded/handleLoadedBill",
                name: "处理重箱提单",
                component: resolve =>
                    require(["../views/business/outCard/trailerLoaded/handleLoadedBill.vue"], resolve),
                meta: {
                    title: "处理重箱提单"
                }
            },
            {
                path: "/outCard/trailerLoaded/tempUser",
                name: "处理临时客户任务",
                component: resolve =>
                    require(["../views/business/outCard/trailerLoaded/tempUser.vue"], resolve),
                meta: {
                    title: "处理临时客户任务"
                }
            },
            {
                path: "/outCard/trailerEmpty/handleEmptyBill",
                name: "处理空箱提单",
                component: resolve =>
                    require(["../views/business/outCard/trailerEmpty/handleEmptyBill.vue"], resolve),
                meta: {
                    title: "处理空箱提单"
                }
            },
            {
                path: "/outCard/trailerCarInfo/carManage",
                name: "集卡车辆管理",
                component: resolve =>
                    require(["../views/business/outCard/trailerCarInfo/carManage.vue"], resolve),
                meta: {
                    title: "集卡车辆管理"
                }
            },
            {
                path: "/outCard/trailerCarInfo/carRegisterList",
                name: "集卡注册申请列表",
                component: resolve =>
                    require(["../views/business/outCard/trailerCarInfo/carRegisterList.vue"], resolve),
                meta: {
                    title: "集卡注册申请列表"
                }
            },
            {
                path: "/outCard/trailerCarInfo/carAudit",
                name: "临时集卡挂靠审核",
                component: resolve =>
                    require(["../views/business/outCard/trailerCarInfo/carAudit.vue"], resolve),
                meta: {
                    title: "临时集卡挂靠审核"
                }
            },
            {
                path: "/outCard/trailerCarInfo/driverManage",
                name: "集卡司机管理",
                component: resolve =>
                    require(["../views/business/outCard/trailerCarInfo/driverManage.vue"], resolve),
                meta: {
                    title: "集卡司机管理"
                }
            },
            {
                path: "/outCard/trailerFee/backFeeList",
                name: "退款列表",
                component: resolve =>
                    require(["../views/business/outCard/trailerFee/backFeeList.vue"], resolve),
                meta: {
                    title: "退款列表"
                }
            },
            {
                path: "/outCard/trailerFee/backNoticeList",
                name: "退款通知",
                component: resolve =>
                    require(["../views/business/outCard/trailerFee/backNoticeList.vue"], resolve),
                meta: {
                    title: "退款通知"
                }
            },
            {
                path: "/outCard/trailerFee/prePaymentFee/:id",
                name: "待支付费用",
                component: resolve =>
                    require(["../views/business/outCard/trailerFee/prePaymentFee.vue"], resolve),
                meta: {
                    title: "待支付费用"
                }
            },
            {
                path: "/outCard/trailerFee/billPaymentFee",
                name: "支付账单",
                component: resolve =>
                    require(["../views/business/outCard/trailerFee/billPaymentFee.vue"], resolve),
                meta: {
                    title: "支付账单"
                }
            },
            {
                path: "/outCard/trailerFee/feeStatisticsList/:id",
                name: "费用统计（按费用名称）",
                component: resolve =>
                    require(["../views/business/outCard/trailerFee/feeStatisticsList.vue"], resolve),
                meta: {
                    title: "费用统计（按费用名称）"
                }
            },
            {
                path: "/outCard/cargoUnpack/unpackHandleLog/:id",
                name: "待处理拆箱任务",
                component: resolve =>
                    require(["../views/business/outCard/cargoUnpack/unpackHandleLog.vue"], resolve),
                meta: {
                    title: "待处理拆箱任务"
                }
            },
            {
                path: "/outCard/cargoUnpack/unpackPlan/:id",
                name: "拆箱计划",
                component: resolve =>
                    require(["../views/business/outCard/cargoUnpack/unpackPlan.vue"], resolve),
                meta: {
                    title: "拆箱计划"
                }
            },
            {
                path: "/outCard/cargoPack/packHandleLog/:id",
                name: "装箱任务处理",
                component: resolve =>
                    require(["../views/business/outCard/cargoPack/packHandleLog.vue"], resolve),
                meta: {
                    title: "装箱任务处理"
                }
            },
            {
                path: "/outCard/cargoPack/packPlan/:id",
                name: "装箱计划",
                component: resolve =>
                    require(["../views/business/outCard/cargoPack/packPlan.vue"], resolve),
                meta: {
                    title: "装箱计划"
                }
            },
            {
                path: "/outCard/inOutHouse/enterPlanList/:id",
                name: "进库计划列表",
                component: resolve =>
                    require(["../views/business/outCard/inOutHouse/enterPlanList.vue"], resolve),
                meta: {
                    title: "进库计划列表"
                }
            },
            {
                path: "/outCard/inOutHouse/outPlanList/:id",
                name: "出库计划列表",
                component: resolve =>
                    require(["../views/business/outCard/inOutHouse/outPlanList.vue"], resolve),
                meta: {
                    title: "出库计划列表"
                }
            },
            {
                path: "/outCard/specialPlan/specialPlanList/:id",
                name: "特殊作业计划列表",
                component: resolve =>
                    require(["../views/business/outCard/specialPlan/specialPlanList.vue"], resolve),
                meta: {
                    title: "特殊作业计划列表"
                }
            },
            {
                path: "/outCard/specialPlan/specialPlanApply",
                name: "特殊作业申请",
                component: resolve =>
                    require(["../views/business/outCard/specialPlan/specialPlanApply.vue"], resolve),
                meta: {
                    title: "特殊作业申请"
                }
            },
            {
                path: "/outCard/cargoFee/feeLog",
                name: "结算费用记录",
                component: resolve =>
                    require(["../views/business/outCard/cargoFee/feeLog.vue"], resolve),
                meta: {
                    title: "结算费用记录"
                }
            },
            {
                path: "/outCard/cargoFee/preFee/:id",
                name: "待结算费用",
                component: resolve =>
                    require(["../views/business/outCard/cargoFee/preFee.vue"], resolve),
                meta: {
                    title: "待结算费用"
                }
            },
            {
                path: "/outCard/fee/feeStatistics/:id",
                name: "费用统计（按费用名称）",
                component: resolve =>
                    require(["../views/business/outCard/fee/feeStatistics.vue"], resolve),
                meta: {
                    title: "费用统计（按费用名称）"
                }
            },
            {
                path: "/outCard/monitor/abnormalInfo",
                name: "异常信息",
                component: resolve =>
                    require(["../views/business/outCard/monitor/abnormalInfo.vue"], resolve),
                meta: {
                    title: "异常信息"
                }
            },
            {
                path: "/outCard/loadedContainer/loadedRecord",
                name: "放重箱完成记录",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/loadedRecord.vue"], resolve),
                meta: {
                    title: "放重箱完成记录"
                }
            },
            {
                path: "/outCard/loadedContainer/reverRecord",
                name: "查看已撤销重箱计划",
                component: resolve =>
                    require(["../views/business/outCard/loadedContainer/reverRecord.vue"], resolve),
                meta: {
                    title: "查看已撤销重箱计划"
                }
            },
            {
                path: "/outCard/emptyContainer/emptyRecord",
                name: "放空箱完成记录",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/emptyRecord.vue"], resolve),
                meta: {
                    title: "放空箱完成记录"
                }
            },
            {
                path: "/outCard/emptyContainer/reverRecord",
                name: "查看已撤销空箱计划",
                component: resolve =>
                    require(["../views/business/outCard/emptyContainer/reverRecord.vue"], resolve),
                meta: {
                    title: "查看已撤销空箱计划"
                }
            },
            {
                path: "/outCard/outContainer/outRecord",
                name: "外进箱完成记录",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/outRecord.vue"], resolve),
                meta: {
                    title: "外进箱完成记录"
                }
            },
            {
                path: "/outCard/outContainer/reverRecord",
                name: "查看已撤销进场计划",
                component: resolve =>
                    require(["../views/business/outCard/outContainer/reverRecord.vue"], resolve),
                meta: {
                    title: "查看已撤销进场计划"
                }
            },
            {
                path: "/outCard/business/shipDetail/:id",
                name: "船公司业务",
                component: resolve =>
                    require(["../views/business/outCard/business/shipDetail.vue"], resolve),
                meta: {
                    title: "船公司业务"
                }
            },
            {
                path: "/outCard/business/truckDetail/:id",
                name: "拖车公司业务",
                component: resolve =>
                    require(["../views/business/outCard/business/truckDetail.vue"], resolve),
                meta: {
                    title: "拖车公司业务"
                }
            },
            {
                path: "/outCard/business/feeInfo",
                name: "费用信息查看",
                component: resolve =>
                    require(["../views/business/outCard/business/feeInfo.vue"], resolve),
                meta: {
                    title: "费用信息查看"
                }
            },
            {
                path: "/outCard/business/shipContailer",
                name: "放箱单位箱信息",
                component: resolve =>
                    require(["../views/business/outCard/business/shipContailer.vue"], resolve),
                meta: {
                    title: "公司箱信息"
                }
            },
            {
                path: "/outCard/business/truckContailer",
                name: "拖车公司箱信息",
                component: resolve =>
                    require(["../views/business/outCard/business/truckContailer.vue"], resolve),
                meta: {
                    title: "拖车公司箱信息"
                }
            },
            {
                path: "/outCard/checkSteam/checkPlan/:id",
                name: "查验计划",
                component: resolve =>
                    require(["../views/business/outCard/checkSteam/checkPlan.vue"], resolve),
                meta: {
                    title: "查验计划"
                }
            },
            {
                path: "/outCard/checkSteam/steamPlan/:id",
                name: "熏蒸计划",
                component: resolve =>
                    require(["../views/business/outCard/checkSteam/steamPlan.vue"], resolve),
                meta: {
                    title: "熏蒸计划"
                }
            },
            {
                path: "/outCard/checkSteam/reverCheckRecord",
                name: "已撤销查验计划",
                component: resolve =>
                    require(["../views/business/outCard/checkSteam/reverCheckRecord.vue"], resolve),
                meta: {
                    title: "已撤销查验计划"
                }
            },
            {
                path: "/outCard/checkSteam/reverSteamRecord",
                name: "已撤销熏蒸计划",
                component: resolve =>
                    require(["../views/business/outCard/checkSteam/reverSteamRecord.vue"], resolve),
                meta: {
                    title: "已撤销熏蒸计划"
                }
            },
            {
                path: "/outCard/forcast/forcastList",
                name: "到货预报列表",
                component: resolve =>
                    require(["../views/business/outCard/forcast/forcastList.vue"], resolve),
                meta: {
                    title: "到货预报列表"
                }
            },
            {
                path: "/outCard/quotaList",
                name: "指标数据查询",
                component: resolve =>
                    require(["../views/business/outCard/quotaList.vue"], resolve),
                meta: {
                    title: "指标数据查询"
                }
            },
            {
                path: "/outCard/carOrderList",
                name: "集卡预约查询",
                component: resolve =>
                    require(["../views/business/outCard/carOrderList.vue"], resolve),
                meta: {
                    title: "集卡预约查询"
                }
            },
            {
                path: "/railwayBoxConsignment/index",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/index.vue"], resolve),
                meta: {
                    title: "铁路箱托运"
                }
            },
            {
                path: "/railwayBoxConsignment/inTransitWagon",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/inTransitWagon.vue"], resolve),
                meta: {
                    title: "在途车皮"
                }
            },
            {
                path: "/railwayBoxConsignment/containerInYard",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/containerInYard.vue"], resolve),
                meta: {
                    title: "在场箱"
                }
            },
            {
                path: "/railwayBoxConsignment/containerInDispatched",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/containerInDispatched.vue"], resolve),
                meta: {
                    title: "已发箱"
                }
            },
            {
                path: "/railwayBoxConsignment/loadUnloadBillmonthly",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/loadUnloadBillmonthly.vue"], resolve),
                meta: {
                    title: "装卸月账单"
                }
            },
            {
                path: "/railwayBoxConsignment/wayBillDowanLoad",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/wayBillDowanLoad.vue"], resolve),
                meta: {
                    title: "到达货票下载"
                }
            },
            {
                path: "/railwayBoxConsignment/sendBillDowanLoad",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/sendBillDowanLoad"], resolve),
                meta: {
                    title: "发送货票下载"
                }
            },
            {
                path: "/railwayBoxConsignment/billMonthlyDetail",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/billMonthlyDetail.vue"], resolve),
                meta: {
                    title: "月账单明细"
                }
            },
            {
                path: "/railwayBoxConsignment/billOtherFee",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/billOtherFee.vue"], resolve),
                meta: {
                    title: "杂费账单"
                }
            },
            {
                path: "/railwayBoxConsignment/boxCostDetails",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/boxCostDetails"], resolve),
                meta: {
                    title: "费用明细"
                }
            },
            {
                path: "/railwayBoxConsignment/statementAccount",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/statementAccount"], resolve),
                meta: {
                    title: "对账单确认"
                }
            },
            // {
            //     path: "/railwayBoxConsignment/loadBillMonthlyDetail",
            //     name: "",
            //     component: resolve =>
            //         require(["../views/business/railwayBoxConsignment/billMonthlyDetailLoad.vue"], resolve),
            //     meta: {
            //         title: "装车月账单明细"
            //     }
            // },
            {
                path: "/railwayBoxConsignment/TYDDGZ",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/TYDDGZ.vue"], resolve),
                meta: {
                    title: "托运订单跟踪"
                }
            },
            {
                path: "/railwayBoxConsignment/TYDDXQ",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/TYDDXQ.vue"], resolve),
                meta: {
                    title: "托运订单详情"
                }
            },
            {
                path: "/railwayBoxConsignment/TYXD",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/TYXD.vue"], resolve),
                meta: {
                    title: "托运下单"
                }
            },
            {
                path: "/railwayBoxConsignment/cargoShipmentInformationManagement",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/cargoShipmentInformationManagement.vue"], resolve),
                meta: {
                    title: "常用发运信息管理"
                }
            },
            {
                path: "/railwayBoxConsignment/cargoInManage",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/cargoInManage.vue"], resolve),
                meta: {
                    title: "常用收货信息管理"
                }
            },
            {
                path: "/railwayBoxConsignment/fieldBoxPlaceOrder",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/fieldBoxPlaceOrder.vue"], resolve),
                meta: {
                    title: "在场箱发送下单"
                }
            },
            {
                path: "/railwayBoxConsignment/fieldBoxPlaceOrderList",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/fieldBoxPlaceOrderList.vue"], resolve),
                meta: {
                    title: "查看托运下单"
                }
            },
            {
                path: "/railwayBoxConsignment/fieldBoxPlaceOrderDetial",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/fieldBoxPlaceOrderDetial.vue"], resolve),
                meta: {
                    title: "托运下单详情"
                }
            },
            {
                path: "/railwayBoxConsignment/approachingWagon",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/approachingWagon.vue"], resolve),
                meta: {
                    title: "即将到达车皮"
                }
            },
            {
                path: "/railwayBoxConsignment/arrivedButnotLeft",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/arrivedButnotLeft.vue"], resolve),
                meta: {
                    title: "已到达未提离"
                }
            },
            {
                path: "/railwayBoxConsignment/deliveryOrderQuery",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/deliveryOrderQuery.vue"], resolve),
                meta: {
                    title: "交付单查询"
                }
            },
            {
                path: "/railwayBoxConsignment/unloadingScheduled",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/unloadingScheduled.vue"], resolve),
                meta: {
                    title: "卸车已计划"
                }
            },
            {
                path: "/railwayBoxConsignment/unloadingCompleted",
                name: "",
                component: resolve =>
                    require(["../views/business/railwayBoxConsignment/unloadingCompleted.vue"], resolve),
                meta: {
                    title: "卸车已完成"
                }
            },
        ]
    },
    {
        path: '/Login',
        name: 'login',
        //component: resolve => require(['../views/login/Login.vue'], resolve),
        component: resolve => require(['../views/login/WLLogin.vue'], resolve),
        meta: {
            title: "登录"
        }
    },
    {
        path: '/android',
        name: 'android',
        component: resolve => require(['../views/login/android.vue'], resolve),
        meta: {
            title: "安卓App下载"
        }
    },
    {
        path: "/Preview",
        name: "preview",
        component: resolve =>
            require(["../views/business/common/preview.vue"], resolve),
        meta: {
            title: "预览"
        }
    },
    {
        path: '/mobilePage/signature',
        name: 'signature',
        //component: resolve => require(['../views/login/Login.vue'], resolve),
        component: resolve => require(['../views/mobilePage/signature.vue'], resolve),
        meta: {
            title: "登录"
        }
    },
];

const router = new Router({
    routes
});

router.afterEach(to => {
    document.title = (to.meta && to.meta.title) || "万州集装箱系统";
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js